import { useEffect, useState } from "react";
import { TimePeriod } from "../../types/Artist"
import { Box, Button, Stack } from "@mui/material";
import React from "react";
import DateField from "./DateField";

type PeriodRowProps = {
    index: number,
    period: TimePeriod,
    handleDelete: (index: number) => void,
    handleChange: (index: number, period: TimePeriod) => void,
}

const PeriodRow = (props: PeriodRowProps) => {
    const [ period, setPeriod ] = useState<TimePeriod>(props.period);

    useEffect(() => {
        props.handleChange(props.index, period);
    }, [props.index, period]);
    
    const handleOriginDateChange = (e: number) => setPeriod({ ...period, origin: { ...period.origin, date: e }});
    const handleOriginMonthChange = (e: number) => setPeriod({ ...period, origin: { ...period.origin, month: e }});
    const handleOriginYearChange = (e: number) => setPeriod({ ...period, origin: { ...period.origin, year: e }});
    const handleEndDateChange = (e: number) => setPeriod({ ...period, end: { ...period.end, date: e }});
    const handleEndMonthChange = (e: number) => setPeriod({ ...period, end: { ...period.end, month: e }});
    const handleEndYearChange = (e: number) => setPeriod({ ...period, end: { ...period.end, year: e }});
    const handleDelete = () => props.handleDelete(props.index);
    
    return (
        <Stack spacing={3}>
            <Box>
                <Stack direction="row" spacing={1}>
                    <DateField value={period.origin?.date} label="Date" handleChange={handleOriginDateChange} />
                    <DateField value={period.origin?.month} label="Month" handleChange={handleOriginMonthChange} />
                    <DateField value={period.origin?.year} label="Year" handleChange={handleOriginYearChange} />
                    <Box>
                        <Button sx={{ my: 0.5 }} variant="outlined" size="small" onClick={handleDelete}>Delete</Button>
                    </Box>                
                </Stack>
            </Box>
            
            <Box>
                <Stack direction="row" spacing={1}>
                    <DateField value={period.end?.date} label="Date" handleChange={handleEndDateChange} />
                    <DateField value={period.end?.month} label="Month" handleChange={handleEndMonthChange} />
                    <DateField value={period.end?.year} label="Year" handleChange={handleEndYearChange} />
                    <Box></Box>
                </Stack>
            </Box>
        </Stack>
    );
}

export default PeriodRow;